<div class="user-panel">
    <div class="user-info">
        <div class="image-container">
            <!-- <div class="user-image"></div> -->
            <i class="dx-icon-user"></i>
        </div>
        @if (user$ | async; as user) {
            <div class="user-name">{{ user.firstName }}</div>
        }
    </div>
    @if (menuMode === 'context') {
        <dx-context-menu
            [items]="menuItems"
            target=".user-button"
            showEvent="dxclick"
            width="170px"
            [position]="{ my: { x: 'center', y: 'top' }, at: { x: 'center', y: 'bottom' } }"
            cssClass="user-menu"
        >
        </dx-context-menu>
    }
    @if (menuMode === 'list') {
        <dx-list class="dx-toolbar-menu-action" [items]="menuItems"> </dx-list>
    }
</div>
